import React, {useState, useEffect} from "react";
import DatePicker from "react-datepicker";

import { FILTER_COUNTRY_SALES_DETALIZATION } from "../../../constants";
import { GET_USER_LEVEL } from "../../../helpers";

import { WidgetGraphSalesReport } from "../widgets/WidgetGraphSalesReport";
import { WidgetGraphSalesByCountry } from "../widgets/WidgetGraphSalesByCountry";
import { WidgetGraphDonutSalesByCountry } from "../widgets/WidgetGraphDonutSalesByCountry";
import { WidgetTableSalesDetalization } from "../widgets/WidgetTableSalesDetalization";
import { CurrencySelect } from "../partials/CurrencySelect";
import { DaysSelect } from "../partials/DaysSelect";

import "./Salesreport.css";

export const Salesreport = (props) => {
  const [countryFilter, setCountryFilter] = useState('all');

  const [filterPayload, setFilterPayload] = useState({
    from: undefined,
    to: undefined,
  });

  return (
    <>
      <div className="Dashboard__content__top-row">
        <h2> Sales report </h2>

        <ul className="Dashboard__content__top-row__selectors">
          <li>
            <DaysSelect 
              changeGlobalDays={props.changeGlobalDays}
              filterFromTo={setFilterPayload}
            />
          </li>
          <li>
            <CurrencySelect changeGlobalCurrency={props.changeGlobalCurrency} />
          </li>
          <li>
            <select className="countr-selector" onChange={(e) => {
              setCountryFilter(e.target.value)
            }}>
              {FILTER_COUNTRY_SALES_DETALIZATION.map((item, i) => {
                return (
                  <option
                    value={item.value}
                    key={i}
                  >
                    {item.label}
                  </option>
                );
              })}
            </select>
          </li>
        </ul>
      </div>

      { parseInt(GET_USER_LEVEL(), 10) < 4 && (
        <div className="simple SalesDetalization__table-filters">
          <div className="input-wrapper datefrom">
            <DatePicker
              dateFormat="yyyy-MM-dd"
              autoComplete="off"
              selected={filterPayload["from"]}
              onChange={(newDate) => {
                setFilterPayload({
                  ...filterPayload,
                  //eslint-disable-next-line
                  ["from"]: newDate,
                });
              }}
              name="from"
              placeholderText="YYYY-MM-DD"
              className="SalesDetalization__search-by-datefrom default-input"
              selectsEnd
            />
          </div>

          <div className="input-wrapper dateto">
            <DatePicker
              dateFormat="yyyy-MM-dd"
              autoComplete="off"
              selected={filterPayload["to"]}
              onChange={(newDate) => {
                setFilterPayload({
                  ...filterPayload,
                  //eslint-disable-next-line
                  ["to"]: newDate,
                });
              }}
              name="to"
              placeholderText="YYYY-MM-DD"
              className="SalesDetalization__search-by-dateto default-input"
              selectsEnd
            />
          </div>
       </div>
      )}

      <WidgetGraphSalesReport
        globalCurrency={props.globalCurrency}
        globalDays={props.globalDays}
        countryFilter={countryFilter}
        filterPayload={filterPayload}
      />

      <div className="Dashboard__content__widget-row">
        <WidgetGraphSalesByCountry
          globalCurrency={props.globalCurrency}
          globalDays={props.globalDays}
          countryFilter={countryFilter}
          filterPayload={filterPayload}

        />
        <WidgetGraphDonutSalesByCountry
          globalCurrency={props.globalCurrency}
          globalDays={props.globalDays}
          countryFilter={countryFilter}
          filterPayload={filterPayload}
        />
      </div>

      <WidgetTableSalesDetalization
        globalCurrency={props.globalCurrency}
        globalDays={props.globalDays}
        countryFilter={countryFilter}
        filterPayload={filterPayload}
      />
    </>
  );
};
